import { Directive, ElementRef, Inject, OnInit } from '@angular/core';
import { Theme, THEME_TOKEN } from '../../types/theme.types';
import { componentStylesByTheme } from '../../utils/theme.utils';
import { style } from '../../utils/style.utils';
import {
  inputLabelStylesSAG,
  inputLabelStylesSHS,
} from './input-label.styles';

@Directive({
  selector: 'label[sag-ui-input-label]',
})
export class InputLabelDirective implements OnInit {
  constructor(
    @Inject(THEME_TOKEN) private readonly theme: Theme,
    private readonly elementRef: ElementRef<HTMLSpanElement>
  ) {}

  ngOnInit(): void {
    const inputLabelStyles = componentStylesByTheme(
      this.theme,
      inputLabelStylesSAG,
      inputLabelStylesSHS
    );
    style(this.elementRef, inputLabelStyles());
  }
}
